export class BlockedClient {
	constructor(model: Partial<BlockedClient>) {
		Object.assign(this, model);
	}

	id: string;
	cpf: string;
	phoneNumber: string;
	secondPhoneNumber: string;
}

export enum FieldsBlockedClient {
	cpf = "cpf",
	phoneNumber = "phoneNumber",
	secondPhoneNumber = "secondPhoneNumber",
}

export const fieldsBlockedClientTranslated: Record<FieldsBlockedClient, string> = {
	[FieldsBlockedClient.cpf]: "CPF",
	[FieldsBlockedClient.phoneNumber]: "Nº de telefone",
	[FieldsBlockedClient.secondPhoneNumber]: "Telefone Alternativo",
};

export function translateFieldsBlockedClient(field?: FieldsBlockedClient): string {
	if (!field) return "";

	if (field?.includes(".")) {
		const fieldSplitted = field.split("");
		const foundDotIndex = fieldSplitted.findIndex(letter => letter === ".");
		const mappingfieldSplitted = fieldSplitted.map((letter, index) => {
			return index === foundDotIndex + 1 ? letter.toLocaleUpperCase() : letter;
		});

		mappingfieldSplitted.splice(foundDotIndex, 1);
		const fieldFormatted = mappingfieldSplitted.join("") as unknown as FieldsBlockedClient;

		return fieldsBlockedClientTranslated[fieldFormatted];
	}

	return fieldsBlockedClientTranslated[field];
}
